export default "/images/vendor/flag-icon-css/flags/4x3/tr.svg?a1a28a5eb8eceaad90b38395a1000ff3";